'use client';

import { useUserNotificationsSubscription } from '@/hooks/useUserNotificationsSubscription';
import { usePresenceHeartbeat } from '@/hooks/usePresenceHeartbeat';
import { useRushMidConfig } from '@/queries/useRushMidConfig';

/**
 * Mounts global Centrifugo subscriptions that aren't tied to a specific
 * screen. Renders nothing — side effects only. Mounted once inside
 * `(app)/AppProviders.tsx` so in-app notification toasts fire no
 * matter which screen the user is currently on.
 */
export function GlobalSubscriptions() {
  useUserNotificationsSubscription();
  usePresenceHeartbeat();
  // Rush Mid gates load at app boot, before the games tile first paints.
  useRushMidConfig();
  return null;
}
